import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    paddingTop: "15px",
    paddingBottom: "70px",
  },
  swapIcon: {
    color: "#EBEBEB",
    width: "24px",
    height: "24px",
    margin: "10px 0px 0px 0px",
  },
  swapIconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  warningContainer: {
    display: "flex",
    alignItems: "center",
    paddingTop: "5px",
    justifyContent: "center",
    color: "#D33636",
    marginTop: "-5px",
  },
  warningMsg: {
    margin: 0,
    fontWeight: 600,
    fontSize: "14px",
    maxWidth: "240px",
    textAlign: "center",
  },
}));
